import React, { useState, useLayoutEffect, useEffect } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { Container, Col } from 'react-bootstrap';

import Header from './Header';
import Footer from './Footer';
import styles from './Layout.module.scss';
import { ApplicationState } from '../../store';

// At runtime, Redux will merge together...
type LayoutProps = { children?: React.ReactNode } & PropsFromRedux;

export const LayoutDisplay = (props: LayoutProps) => {
  const { children, pathname } = props;

  const minimumWindowHeight = window.innerHeight * 0.6;
  const contentContainer = document.getElementsByClassName(
    'content-container'
  )[0];

  const [contentHeight, setContentHeight] = useState(minimumWindowHeight);
  const [sizerStyle, setSizerStyle] = useState({
    height: `${minimumWindowHeight}px`,
  });

  // return a either the minimumWindowHeight or the contentHeight if it's larger
  const calculateNewContentHeight = () => {
    let height = minimumWindowHeight;
    if (
      contentContainer &&
      contentContainer.clientHeight > minimumWindowHeight
    ) {
      height = contentContainer.clientHeight;
    }
    return height;
  };

  const doHeightStuff = () => {
    const newHeight = calculateNewContentHeight();
    if (newHeight !== contentHeight) setContentHeight(newHeight);
  };

  // when window is resized, check contentHeight (resizing)
  window.addEventListener('resize', () => {
    doHeightStuff();
  });

  // when route changes occur, check contentHeight (navigation)
  useEffect(() => {
    // also scroll the window to the top
    window.scrollTo(0, 0);
    // run it after 1/4 of a second to ensure that the contentContainer used
    // for this is not the one from the previous screen
    // feels a little hacky /shrug
    setTimeout(() => {
      doHeightStuff();
    }, 250);
  }, [pathname]); // eslint-disable-line react-hooks/exhaustive-deps

  // when all api calls are done, recalc in case of alerts displayed on
  // page affecting the height
  // useEffect(() => {
  //   if (apiCallsInProgress === 0) {
  //     setTimeout(() => {
  //       doHeightStuff();
  //     }, 250);
  //   }
  // }, [apiCallsInProgress]);// eslint-disable-line react-hooks/exhaustive-deps

  // before DOM is done rendering, check contentHeight (refreshes)
  useLayoutEffect(() => {
    doHeightStuff();
  });

  // set sizerStyle on contentHeight changes
  useEffect(() => {
    setSizerStyle({ height: `${contentHeight}px` });
  }, [contentHeight]);

  return (
    <Container fluid>
      <Header />
      <div className={styles.colorbar} />
      <div id='contentSizer' style={sizerStyle} />
      <div id='mainContent' className={styles.mainContent}>
        <Col xs={12} sm={10} md={9} className='mx-auto'>
          <div className='container-shadow'>
            <Container className='content-container'>{children}</Container>
          </div>
        </Col>
      </div>
      <Footer />
    </Container>
  );
};

const mapProps = (state: ApplicationState) => ({
  pathname: state.router.location.pathname,
});

const mapDispatch = {};

const connector = connect(mapProps, mapDispatch);

type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(LayoutDisplay);
